"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMomentAuthConfig = void 0;
const CookieStateStore_1 = require("./CookieStateStore");
/**
 * Returns the AuthProvider props to pass to react-oidc-context's <AuthProvider>.
 *
 * Keeping this as a config factory (not a wrapper component) avoids the
 * dual-module-instance problem: the compiled CommonJS package and the app's
 * ESM imports would resolve to different react-oidc-context instances,
 * creating two separate React contexts and breaking useAuth().
 * By never importing react-oidc-context here, the app owns the single instance.
 */
const buildMomentAuthConfig = (options) => ({
    authority: options.authority,
    client_id: options.clientId,
    redirect_uri: options.redirectUri,
    response_type: 'code',
    scope: 'email openid profile',
    userStore: new CookieStateStore_1.CookieStateStore(),
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: () => {
        localStorage.setItem('redirectURL', window.location.pathname);
    },
});
exports.buildMomentAuthConfig = buildMomentAuthConfig;
